import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";

// Components
import CartItem from "../components/CartItem";

// Actions
import { addToCart, removeFromCart } from "../redux/actions/cartActions";

const CartScreen = ({ storeCurrency, currentUser }) => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const qtyChangeHandler = (item, qty) => {
    dispatch(addToCart(item, qty));
  };

  const removeFromCartHandler = (item) => {
    dispatch(removeFromCart(item));
  };

  const getCartCount = () => {
    // return cartItems.reduce((qty, item) => Number(item.qty) + qty, 0);
    return cartItems.length;
  };

  const getCartSubTotal = () => {
    return cartItems
      .reduce((price, item) => price + item.product.price * item.quantity, 0)
      .toFixed(2);
  };

  return (
    <div>
      <Breadcrumb heading={"Cart"} />
      <div className="container mx-auto">
        <div className="container mx-auto p-4 my-12">
          <div className="cart">
            <table className="table-auto w-full">
              <thead className="border-b">
                <tr>
                  <th className="text-left">Product</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.length === 0 ? (
                  <tr className="pt-4">
                    <td style={{ textAlign: "left" }}>
                      Your Cart is empty 😒 <Link to="/">Go Back</Link>
                    </td>
                  </tr>
                ) : (
                  cartItems.map((item, index) => (
                    <CartItem
                      key={index}
                      item={item.product}
                      quantity={item.quantity}
                      qtyChangeHandler={qtyChangeHandler}
                      removeHandler={removeFromCartHandler}
                      storeCurrency={storeCurrency}
                    />
                  ))
                )}
                {cartItems.length > 0 ? (
                  <tr className="border-b">
                    <td></td>
                    <td></td>
                    <td className="font-bold">
                      Subtotal ({getCartCount()}) items
                    </td>
                    <td>
                      {storeCurrency} {getCartSubTotal()}
                    </td>
                  </tr>
                ) : (
                  <tr></tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="border-b flex justify-end gap-4 py-6">
            <div>
              <Link to="/shop" className="info__button">
                Continue Shopping
              </Link>
            </div>
            <div>
              {currentUser?.id ? (
                cartItems?.length > 0 ? (
                  <Link to="/order" className="info__button">
                    Proceed To Checkout
                  </Link>
                ) : (
                  ""
                )
              ) : cartItems?.length > 0 ? (
                <Link className="info__button" to="/account">
                  Login To Checkout
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartScreen;
